module.exports = __webpack_public_path__ + "static/media/briefcase.8279bad2.svg";